export const BOXES_QUANTITY_MODAL_LIST = [
  {
    key: '1-box',
    option: '1 Box (1 mth supply)',
  },
  {
    key: '2-box',
    option: '2 Box (2 mth supply)',
  },
  {
    key: '4-box',
    option: '4 Box (4 mth supply)',
  },
  {
    key: '6-box',
    option: '6 Box (6 mth supply)',
  },
];

export const SELECT_POWER_MODAL_LIST = [
  {
    key: '-0.50',
    option: '-0.50',
  },
  {
    key: '-0.75',
    option: '-0.75',
  },
  {
    key: '-1.00',
    option: '-1.00',
  },
  {
    key: '-1.25',
    option: '-1.25',
  },
  {
    key: '-1.50',
    option: '-1.50',
  },
  {
    key: '-1.75',
    option: '-1.75',
  },
  {
    key: '-2.00',
    option: '-2.00',
  },
  {
    key: '-2.25',
    option: '-2.25',
  },
  {
    key: '-2.50',
    option: '-2.50',
  },
  {
    key: '-2.75',
    option: '-2.75',
  },
  {
    key: '-3.00',
    option: '-3.00',
  },
];
